(function() {
  'use strict';

  angular
    .module('cfn')
    .directive('cfnBookingAttachments', cfnBookingAttachments);

  cfnBookingAttachments.$inject = [
    'bookingRules',
    'bookingAttachmentService',
    'i18nFilter'
  ];

  function cfnBookingAttachments(
    bookingRules,
    bookingAttachmentService,
    i18nFilter
  ) {
    return {
      restrict: 'E',
      templateUrl: require('./attachmentsTable.html'),
      controller: [
        '$scope',
        function($scope) {
          $scope.closeAttachmentPopup = function() {
            $scope.showContent = false;
          };

          $scope.showAttachment = function(attachmentId) {
            bookingAttachmentService
              .getAttachmentContent(attachmentId)
              .then(function(content) {
                $scope.showContent = content
                  ? content
                  : '< ' +
                    i18nFilter('fe.common.noContents', 'No Contents') +
                    ' >';
              });
          };

          // DataModel -> ViewModel
          bookingRules.elements.attachments.onLoad = function(result) {};
        }
      ]
    };
  }
})();
